/**
 * Share buttons
 * 
 * @since 1.3.5
 * @author FriskaMax <support@friskamax.com>
 * @param {jQuery} $
 */
(function($) { 
    'use strict';
    
    var EVENT_NAMESPACE = '.warta.share-buttons';
    var SELECTOR = {
        COUNTS_WRAPPER: '[data-share-counts-wrapper]',
        COUNT: '[data-share-count]',
        LINK_SHARE: '.share-post a'
    };
    var $document = $(document);
    var $wrapper = $(SELECTOR.COUNTS_WRAPPER);
    
    $wrapper.find(SELECTOR.COUNT).each(function() {
        var $this = $(this);
        
        $.get($wrapper.data('api-url'), {
            social_media: $this.data('share-count')
        }, function (response) {       
            if (!response) {
                return;
            }

            $this.html(response).removeClass('hidden');
        });
    });
        
        
    $document.on('click' + EVENT_NAMESPACE, SELECTOR.LINK_SHARE, function (event) {
        var href = $(this).attr('href');

        if(/^http.+$/.test(href)) {   
            window.open(href, '', 'width=800,height=550');
            event.preventDefault();     
        }
    });
})(jQuery);